<div class="course-list-container">
  <div class="header">
    <h2>Courses</h2>
    <div class="actions">
      <mat-form-field appearance="outline" *ngIf="isTeacher || isAdmin">
        <mat-label>Filter by Status</mat-label>
        <mat-select [(ngModel)]="filterStatus" (selectionChange)="loadCourses()">
          <mat-option value="">All</mat-option>
          <mat-option value="ACTIVE">Active</mat-option>
          <mat-option value="DRAFT">Draft</mat-option>
          <mat-option value="COMPLETED">Completed</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-raised-button color="primary" *ngIf="isTeacher || isAdmin" (click)="createCourse()">
        <mat-icon>add</mat-icon>
        New Course
      </button>
    </div>
  </div>

  <mat-spinner *ngIf="loading" diameter="50" class="spinner"></mat-spinner>

  <div class="courses-grid" *ngIf="!loading">
    <mat-card *ngFor="let course of courses" class="course-card" (click)="viewCourse(course.id!)">
      <mat-card-header>
        <mat-card-title>{{ course.name }}</mat-card-title>
        <mat-card-subtitle>{{ course.code }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p>{{ course.description }}</p>
        <div class="course-info">
          <span class="info-item">
            <mat-icon>person</mat-icon>
            {{ course.teacherName }}
          </span>
          <span class="info-item">
            <mat-icon>group</mat-icon>
            {{ course.enrollmentCount || 0 }} enrolled
          </span>
          <span class="info-item status" [ngClass]="getStatusClass(course.status || '')">
            {{ course.status }}
          </span>
        </div>
      </mat-card-content>
      <mat-card-actions *ngIf="isTeacher || isAdmin">
        <button mat-button (click)="editCourse(course.id!); $event.stopPropagation()">
          <mat-icon>edit</mat-icon>
          Edit
        </button>
        <button mat-button color="warn" (click)="deleteCourse(course.id!); $event.stopPropagation()">
          <mat-icon>delete</mat-icon>
          Delete
        </button>
      </mat-card-actions>
    </mat-card>
  </div>

  <div *ngIf="!loading && courses.length === 0" class="empty-state">
    <mat-icon>school</mat-icon>
    <p>No courses found</p>
  </div>
</div>
